import { createEventFactory } from '@cp/shared/tracking';

export const notificationEnabled = createEventFactory({
  subject: 'notification',
  action: 'enable',
  result: 'success',
  nonInteraction: true,
  goalId: 'podpiska_na_pushi_aktivirovana',
  goalName: 'Подписка на пуши активирована',
});

export const notificationBannerClick = createEventFactory({
  subject: 'notification',
  object: 'banner',
  action: 'click',
  goalId: 'nazhatie_na_vkluchite_pushi',
  goalName: 'Нажатие на кнопку "Включите уведомления чтобы не пропустить важное"',
});
